import React, { useState } from "react";
import { C, font, btnP, btnS } from "../lib/styles.js";

/* Stops any move away from a saved or booked quote with unsaved edits
   (lib/quotePersistence.js beginReplace). Save runs the normal save and stays open with
   the reason if it can't. Discard throws the edits away. Cancel goes back to the open
   quote with everything still there. */
export default function UnsavedQuoteDialog({ prompt, lock = null }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const { quote, booked, save, done } = prompt;
  // The lock's own state (lib/quotePersistence.js): a save that passed its time limit
  // says so here, above everything, since this dialog covers the builder's message.
  const stuck = lock?.stuck ? lock.message : "";

  const onSave = async () => {
    setBusy(true);
    setError("");
    try {
      await save();
      done("saved");
    } catch (e) {
      setError(e?.userMessage || e?.message || "The quote could not be saved.");
      setBusy(false);
    }
  };

  return (
    <div role="dialog" aria-modal="true" aria-label="Unsaved edits" data-testid="unsaved-quote-dialog" style={S.backdrop}>
      <div style={S.card}>
        <div style={S.title}>This quote has edits that aren't saved</div>
        <div style={S.body}>
          {quote?.clientName || "This quote"} ({quote?.id}).
          {booked ? " It is booked, so saving updates the quote the job reads from." : ""}
          {" "}Save keeps the edits. Discard throws them away. Cancel goes back to the quote.
        </div>
        {error && <div style={S.error} data-testid="unsaved-quote-error">{error}</div>}
        {stuck && <div style={S.error} data-testid="unsaved-quote-stuck">{stuck}</div>}
        <div style={S.buttons}>
          <button type="button" style={{ ...btnS, opacity: busy ? 0.5 : 1 }} disabled={busy} onClick={() => done("cancel")}>Cancel</button>
          <button type="button" style={{ ...btnS, color: C.danger, opacity: busy ? 0.5 : 1 }} disabled={busy} onClick={() => done("discard")}>Discard</button>
          <button type="button" style={{ ...btnP, opacity: busy ? 0.5 : 1 }} disabled={busy} onClick={onSave}>{busy ? "Saving…" : "Save"}</button>
        </div>
      </div>
    </div>
  );
}

const S = {
  // Above everything that can ask this question, version history (10000) included.
  backdrop: { position: "fixed", inset: 0, background: "rgba(26,26,26,0.35)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16, zIndex: 10001, fontFamily: font },
  card: { background: C.surface, border: `1px solid ${C.border}`, borderRadius: 10, padding: 20, maxWidth: 460, width: "100%", boxSizing: "border-box" },
  title: { fontSize: 15, color: C.text, marginBottom: 8 },
  body: { fontSize: 13, color: C.muted, lineHeight: 1.5 },
  error: { fontSize: 12, color: C.danger, marginTop: 10, lineHeight: 1.5 },
  buttons: { display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16, flexWrap: "wrap" },
};
